import { Component, inject, Input, OnInit } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'marketing-notification',
    imports: [],
    templateUrl: './marketing-notification.component.html',
    styleUrl: './marketing-notification.component.scss'
})
export class MarketingNotificationComponent implements OnInit {
    #sanitizer = inject(DomSanitizer)
    #modalService = inject(BsModalService)
    
    @Input() notification: any
    @Input() html: string
    @Input() salesCompetitionData: any
    @Input() modalId: string

    safeHtml: SafeHtml

    ngOnInit(): void {

        this.safeHtml = this.#sanitizer.bypassSecurityTrustHtml(this.html)

        if (this.notification.SECONDSTODISPLAYPOPUP > 0) {
            const delayModal = this.notification.SECONDSTODISPLAYPOPUP * 1000

            setTimeout(() => {
                this.close()
            }, delayModal)
        }
    }

    close() {
        this.#modalService.hide(this.modalId)
    }

    openSalesCompetition() {
        if (this.salesCompetitionData && this.salesCompetitionData.Url && this.salesCompetitionData.Hash) {
            const url = this.salesCompetitionData.Url
            const hash = this.salesCompetitionData.Hash
            window.open("" + url + encodeURI(hash), "_blank")
        }
    }
}
